<template>
    <div class="tabs_content baseInfo">
       
        <!-- <div class="title1">专利附图</div> -->
        <div class="img_list" id="image" v-if="imgList.length>0">
            <div class="item" v-for="(item,index) in imgList" :key="index" :title="item.name" >
                <img :src="$store.state.baseUrl + item.bigPath" :data-original='$store.state.baseUrl + item.bigPath' alt="" @click="initImg">
                <div class="text">{{item.name}}</div>
            </div>
        </div>
        <div class="img_list" v-else>
            <span>暂无图片信息</span>
        </div>
    </div>
</template>
<script>
import {mapActions} from'vuex'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import { Console } from 'console'
export default {
    name:"patentImage",
        props:{
        pid:{
            id:''
        }
    },
    data(){
        return{

            viewer:'',
            imgList:[]
        }
    },
        watch:{
           
            pid:{
                handler(n,o){
                    console.log(n,o)
                    this.getImage(n.id)
                    
                },
                deep:true
                
            },
            
        },
        mounted(){
        this.initImg();
    },
         created(){
         console.log(200000,this.pid)
         this.getImage(this.pid.id)
         this.initImg()
        },
        methods:{
            ...mapActions('search',['getPatentDraw']),
            getImage(val) {
            this.loading = true
            this.imgList = []
            let data = {
                params: {
                   udn: val
                }
            }
            let _this = this
            this.getPatentDraw({data: data,handle(res) {
                _this.imgList = res.patent&&res.patent.drawings || []
                _this.loading = false
            }})
        },
        initImg() {
            const ViewerDom = document.getElementById('image');
            console.log(ViewerDom,100000000)
              const viewer = new Viewer(ViewerDom, {
                url: "data-original",
                show: function(){
                      viewer.update();
                }
            });
            
        },
        updateImg() {
            
           this.viewer.update()
        },
        },
}
</script>